<div class="quantity row row_ai_center">
    <button type="button" class="btn row" (click)="decrease()">
        <span class="material-symbols-outlined">remove</span>
    </button>
    <input type="number" [value]="quantity" min="1" class="inp inp_numeric" readonly>
    <button type="button" class="btn row" (click)="increase()">
        <span class="material-symbols-outlined">add</span>
    </button>
</div>